import { faCopy } from '@fortawesome/pro-light-svg-icons'
import { useCallback } from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'
import useTwinTranslation from '../../../utils/hooks/useTwinTranslation'
import { changeSuccessMessage } from '../../../utils/reducers/reduxDispatch'
import TwinIcon, { TwinIconProp } from '../../TwinIcon'

interface DisplayTextWithCopyProps {
    text?: string
    icon: TwinIconProp
}

export const DisplayTextWithCopy: React.FC<DisplayTextWithCopyProps> = ({ text, icon }) => {
    const { handleCopy } = DisplayTextWithCopyLogic()
    if (!text) {
        return null
    }
    return (
        <div className='flex items-center'>
            <div className='mr-10 w-16'>
                <TwinIcon icon={icon} />
            </div>
            <span className='mr-10'>
                {text}
            </span>
            {text?.length ?
                <CopyToClipboard text={text || ''} onCopy={handleCopy}>
                    <TwinIcon className='ml-auto cursor-pointer hover:text-green-43' icon={faCopy} />
                </CopyToClipboard>
                : null
            }
        </div>
    )
}

const DisplayTextWithCopyLogic = () => {
    const { t } = useTwinTranslation()
    const correctlyCopied = t('copiedCorrectly', 'Copiado correctamente')
    const handleCopy = useCallback(() => {
        changeSuccessMessage(correctlyCopied)
    }, [correctlyCopied])
    return { handleCopy }
}

export default DisplayTextWithCopy